export default __webpack_public_path__ + "static/media/confectionery-badge-waves.24df2da4.svg";